module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "rev"
    }
  }, [_c('p', {
    staticClass: "rvh"
  }, [_vm._v("Advance Praise for "), _c('i', [_vm._v("My Old Faithful")])]), _vm._v(" "), _c('p', {
    staticClass: "rv"
  }, [_vm._v("“Yang Huang’s collection of linked stories peels back the layers of a culture too often rendered exotic and opaque to reveal what is intimate and familiar. Sexual awakenings, sibling rivalries, the pain and joy of raising children, aging, the constraints of love and loyalty are all dealt here with a gentle and incisive hand. "), _c('i', [_vm._v("My Old Faithful")]), _vm._v(" is a deeply moving portrait of a family and a society.”")]), _vm._v(" "), _c('p', {
    staticClass: "rvt"
  }, [_vm._v("—Hasanthika Sirisena, author of "), _c('i', [_vm._v("The Other One")])]), _vm._v(" "), _c('p', {
    staticClass: "rv"
  }, [_vm._v("“In "), _c('i', [_vm._v("My Old Faithful,")]), _vm._v(" Yang Huang explores with humor, tenderness and fierce precision the ties that bind and separate a family across time and space. Filled with unexpected turns and a painterly attention to detail, this is a wise and beautiful book.”")]), _vm._v(" "), _c('p', {
    staticClass: "rvt"
  }, [_vm._v("—Elizabeth Graver, author of "), _c('i', [_vm._v("The End of the Point")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff2a77c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uma-HUANG-0002.vue
// module id = 60
// module chunks = 0